$(function () {
    const body = $('body');
    const nav = $('.nav');
    const burger = $('.burger');
    const nav_trigger = $('.nav').find('ul li.menu-item-has-children > button, ul li.menu-item-has-children > a');
    const nav_align = 'right';
    const break_point = 992;
    const browser_width = window.innerWidth;
    const nav_window = $('<div class="navwindow"></div>');
    body.append(nav_window);
    const nav_wrap = $('.navwrap');

    /*nav reset*/
    const nav_reset = function nav_reset() {
        burger.removeClass('__active');
        nav_window.hide();
        body.removeClass('__mobile');
        nav_wrap.removeClass('__active');
        nav_wrap.find('ul, div').removeClass('__active');
        body.removeClass('__blur');
    };

    document.addEventListener('keydown', function (event) {
        const key = event.key;
        if (key === "Escape") {
            if (browser_width < break_point) {
                nav_reset();
                burger.focus();
            } else {
                $('.menu-item-has-children').removeClass('__active');
                body.removeClass('__blur');
            }
        }
    });

    nav_window.click(function (event) {
        nav_reset();
    });

    //burger click
    burger.click(function (event) {
        event.preventDefault();
        $(this).toggleClass('__active');
        if (body.hasClass('__mobile')) {
            nav_reset();
        } else {
            nav_launch();
        }
    });

    /*nav launch*/
    const nav_launch = function nav_launch() {
        nav_window.show();
        body.addClass('__mobile');
        nav_wrap.addClass('__active');
    };

    
    function initMenu() {
        const browser_width = window.innerWidth;

         // nav dropdown on focus/keyboard navigation
        if (browser_width >= break_point) {
            nav_trigger.click(function (event) {
                if($(this).is('button')) {
                    event.preventDefault();
                    $(this).parent().siblings().removeClass('__active');
                    $(this).parent().siblings().find('.__active').removeClass('__active');
                    $(this).parent().siblings().find('[aria-expanded="true"]').attr('aria-expanded', false);
                    $(this).parent().toggleClass('__active');
                    if($(this).parent().hasClass( '__active' )) {
                        $(this).attr('aria-expanded', true);
                    } else {
                        $(this).attr('aria-expanded', false);
                        $(this).parent().find('.__active').removeClass('__active');
                    }
                }
            });

            $(document).on("click", function (event) {
                if ($(event.target).closest(".nav[aria-label='Primary']").length === 0) {
                    nav.find('.__active').removeClass('__active');
                    nav.find('[aria-expanded="true"]').attr('aria-expanded', false);
                    body.removeClass('__blur');
                }
            });
        }

        if (browser_width < break_point) {
            nav_trigger.click(function (event) {
                event.stopPropagation();
                if ($(this).parent().children('ul').length > 0) {
                    $(this)
                        .parent().children('ul')
                        .addClass('__active');
                    $(this)
                        .parent().children('ul').find('li:first-child a, li:first-child button').focus();
                }
            });

            // Disable root item link click
            $('.menu-item-has-children > a').click(function (event) {
                event.preventDefault();
            });
        }

        if (browser_width < break_point) {

            nav.find('a, button').attr('tabindex', '-1');
            const back_menu = $('.backto');
            back_menu.click(function (event) {
                event.preventDefault();
                event.stopPropagation();
                $(this)
                    .parents('li')
                    .parent('ul')
                    .addClass('__active');
                $(this)
                    .parents('li').children('a').focus();
            });

        } else {
            nav_reset();
        }
        

        // Touch device check
        const isTouchDevice = () => {
            return window.matchMedia("(pointer: coarse)").matches
        }
        
        // If desktop and touch device, disable link click and add extra view link
        if (browser_width > break_point && isTouchDevice()) {
            nav_trigger.click(function (event) {
                event.stopPropagation();
                if ($(this).children('ul').length > 0) {
                    event.preventDefault();
                }
            });
        }

        const view_all = $('.viewall');
        view_all.click(function (event) {
            event.stopPropagation();
        });

        const back_menu = $('.backto button');
        back_menu.click(function (event) {
            event.preventDefault();
            event.stopPropagation();
            $(this).closest('.__active').removeClass('__active');
        });
    }

    function InitMenuOnLoad() {
        if ($('.navwrap > .nav').length) {
            initMenu();
        } else {
            setTimeout(InitMenuOnLoad, 200);
        }
    }

    $(window).on('load', function () {
        InitMenuOnLoad();
    });

    $(window).on('resize', function(){
        initMenu();
    });

    function getPrimaryNav() {
        return document.querySelector('.nav[aria-label="Primary"]');
    }

    function isMobileMenu() {
        return window.innerWidth < break_point;
    }

    function isDesktopTouchDevice() {
        return window.innerWidth > break_point && window.matchMedia('(pointer: coarse)').matches;
    }

    function clearNestedState(root) {
        root.querySelectorAll('.__active').forEach(function (element) {
            element.classList.remove('__active');
        });

        root.querySelectorAll('[aria-expanded="true"]').forEach(function (element) {
            element.setAttribute('aria-expanded', 'false');
        });
    }

    function closeSiblingBranches(item) {
        let sibling = item.parentElement ? item.parentElement.firstElementChild : null;

        while (sibling) {
            if (sibling !== item) {
                sibling.classList.remove('__active');
                sibling.querySelectorAll('.__active').forEach(function (element) {
                    element.classList.remove('__active');
                });
                sibling.querySelectorAll('[aria-expanded="true"]').forEach(function (element) {
                    element.setAttribute('aria-expanded', 'false');
                });
            }

            sibling = sibling.nextElementSibling;
        }
    }

    function openMobileSubmenu(submenu) {
        submenu.classList.add('__active');

        const focusTarget = submenu.querySelector('li:first-child a, li:first-child button');
        if (focusTarget) {
            focusTarget.focus();
        }
    }

    function toggleDesktopSubmenu(trigger, item) {
        const isActive = item.classList.contains('__active');

        closeSiblingBranches(item);

        if (isActive) {
            item.classList.remove('__active');
            trigger.setAttribute('aria-expanded', 'false');
            item.querySelectorAll('.__active').forEach(function (element) {
                element.classList.remove('__active');
            });
            trigger.blur();
            return;
        }

        item.classList.add('__active');
        trigger.setAttribute('aria-expanded', 'true');
    }

    document.addEventListener('click', function (event) {
        const trigger = event.target.closest('li.menu-item-has-children > button, li.menu-item-has-children > a');
        if (!trigger) {
            return;
        }

        const primaryNav = getPrimaryNav();
        if (!primaryNav?.contains(trigger)) {
            return;
        }

        const item = trigger.parentElement;
        const submenu = item ? item.querySelector(':scope > ul') : null;
        if (!item || !submenu) {
            return;
        }

        if (!isMobileMenu()) {
            if (trigger.tagName === 'BUTTON') {
                event.preventDefault();
                event.stopImmediatePropagation();
                toggleDesktopSubmenu(trigger, item);
                return;
            }

            if (isDesktopTouchDevice() && trigger.tagName === 'A') {
                event.preventDefault();
                event.stopImmediatePropagation();
            }

            return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        openMobileSubmenu(submenu);
    }, true);

    document.addEventListener('click', function (event) {
        const backButton = event.target.closest('.backto button');
        if (!backButton) {
            return;
        }

        const primaryNav = getPrimaryNav();
        if (!primaryNav?.contains(backButton)) {
            return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        const activeMenu = backButton.closest('.__active');
        if (activeMenu) {
            activeMenu.classList.remove('__active');
        }
    }, true);

    document.addEventListener('click', function (event) {
        if (isMobileMenu()) {
            return;
        }

        const primaryNav = getPrimaryNav();
        if (!primaryNav) {
            return;
        }

        if (!primaryNav.contains(event.target)) {
            clearNestedState(primaryNav);
        }
    }, true);
});
